import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'sd-item-wrapper',
  imports: [],
  templateUrl: './item-wrapper.component.html',
  styleUrl: './item-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.active]': 'isActive()',
  },
})
export class ItemWrapperComponent {
  readonly isActive = input();
}
